export default "__VITE_ASSET__nM4Lk61b__"